import { useState } from 'react';
import SignatureField from './SignatureField';

const consentTexts = {
  hair: `Hair Service Consent

I have read the above information and have given an accurate account of all the questions. If I have any concerns I will address it with my stylist before our session begins.

I give my stylist full permission to perform any chemical services discussed and agreed upon.

I have had the chance to ask any questions I may have.

I will not hold the establishment nor the stylist accountable for any liabilities that may result from this service.

I understand that my stylist will take every precaution to ensure the integrity of my hair and/or eliminate any risk involved with the chemical treatments.

DATA PROTECTION (POPIA)

By signing below, I consent to Muse & Mane collecting and storing my personal information including my name, contact details, medical history, hair records, and treatment history.

I understand that my information is necessary to provide safe and appropriate services. My information will only be used for service delivery, treatment recommendations, aftercare, and legal/insurance requirements.

I have the right to access, correct, or withdraw my data at any time.

This consent is valid for 1 year from the date of signing.`,

  skin: `Skin Service Consent

I acknowledge that no guarantee has been made about the result of the procedure. Although it is impossible to list every potential risk and complication, I have been informed of the possible risk and complications which may include, but are not limited to the following:

- Stinging, Itching or Irritation
- Redness or Swelling of the Skin
- Tightness, Peeling or Scabbing of Treated Skin
- Skin Sensitivity / Breakout can occur temporarily
- Darkness of the skin which will crust & peel off

I understand that I should not have chemical peels if I intend to have excessive sun exposure.

I have read & understand the above. My skin therapist has explained the precautionary measures I need to take.

DATA PROTECTION (POPIA)

By signing below, I consent to Muse & Mane collecting and storing my personal information including my name, contact details, medical history, skin records, and treatment history.

I understand that my information is necessary to provide safe and appropriate services. My information will only be used for service delivery, treatment recommendations, aftercare, and legal/insurance requirements.

I have the right to access, correct, or withdraw my data at any time.

This consent is valid for 1 year from the date of signing.`
};

function ConsentForm({ clientId, clientName, type, onSigned, onCancel, isClient = false }) {
  const [formData, setFormData] = useState({
    clientSignature: '',
    staffName: isClient ? 'Client Self-Signed' : '',
    staffSignature: isClient ? 'Client Self-Signed' : ''
  });
  const [consentChecked, setConsentChecked] = useState(false);
  const [saving, setSaving] = useState(false);

  const consentText = consentTexts[type] || consentTexts.hair;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!consentChecked) {
      alert('Please acknowledge the consent terms');
      return;
    }
    if (!formData.clientSignature) {
      alert('Please provide your signature');
      return;
    }
    if (!isClient && (!formData.staffName || !formData.staffSignature)) {
      alert('Please complete staff name and signature');
      return;
    }
    setSaving(true);
    await onSigned(formData);
    setSaving(false);
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-6">
      <div className="bg-gray-50 p-4 rounded-md text-sm whitespace-pre-wrap max-h-96 overflow-y-auto">
        {consentText}
      </div>
      
      <div className="mb-4">
        <label className="flex items-center gap-2">
          <input type="checkbox" checked={consentChecked} onChange={(e) => setConsentChecked(e.target.checked)} className="h-4 w-4" />
          <span className="text-sm">I have read and understand the above information and agree to the terms.</span>
        </label>
      </div>
      
      <SignatureField
        label="Your Signature (Type Full Name)"
        value={formData.clientSignature}
        onChange={(val) => setFormData({...formData, clientSignature: val})}
        required
      />
      
      {!isClient && (
        <>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">Staff Name</label>
            <input 
              type="text" 
              value={formData.staffName} 
              onChange={(e) => setFormData({...formData, staffName: e.target.value})} 
              className="w-full px-3 py-2 border rounded-md" 
              required 
            />
          </div>
          
          <SignatureField
            label="Staff Signature (Type Full Name)"
            value={formData.staffSignature}
            onChange={(val) => setFormData({...formData, staffSignature: val})}
            required
          />
        </>
      )}
      
      <div className="flex justify-end gap-3">
        <button type="button" onClick={onCancel} className="px-4 py-2 bg-gray-200 rounded-md">Cancel</button>
        <button type="submit" disabled={saving} className="px-4 py-2 bg-salon-button text-white rounded-md disabled:opacity-50">
          {saving ? 'Saving...' : 'Sign Consent'}
        </button>
      </div>
    </form>
  );
}

export default ConsentForm;